<template>
    <div class="TimesheetReport">
        <div class="metaHeader meta">
            <h1>Hours Summary</h1>
            <div class="third">
                <ReportMetaRow title="Dates" :value="dates" />
            </div>
        </div>

        <table class="main">
            <tbody v-for="(driver, index) in report.drivers" :key="driver.id">
                <h2 :class="{ pageBreak: index !== 0 }">
                    {{ `${driver.user.firstName} ${driver.user.lastName}` }}
                </h2>
                <table class="tickets">
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Ticket #</th>
                            <th>Project</th>
                            <th>Notes</th>
                            <th>Truck</th>
                            <th>Start Time</th>
                            <th>End Time</th>
                            <th>Pre Trip</th>
                            <th>Mobilization</th>
                            <th>Standby</th>
                            <th>Demobilization</th>
                            <th>Post Trip</th>
                            <th>Indirect Hours</th>
                            <th>Direct Hours</th>
                            <th>Total Hours</th>
                        </tr>
                    </thead>
                    <tbody v-for="(ticket, index) in driver.tickets" :key="ticket.id">
                        <tr>
                            <td width="7%">{{ formatDate(ticket.submittedAt, timeZone) }}</td>
                            <td width="5%">{{ ticket.ticketNumber }}</td>
                            <td width="20%">{{ truncate(ticket.project.name, { length: 50 }) }}</td>
                            <td width="25%">{{ truncate(ticket.notes, { length: 75 }) }}</td>
                            <td width="8%">{{ truncate(ticket.truck.name, { length: 25 }) }}</td>
                            <td width="20%">{{ formatDateTime(ticket.precheckStartAt, timeZone, 'M/d/yy h:mm a') }}</td>
                            <td width="20%">{{ formatDateTime(ticket.postcheckEndAt, timeZone, 'M/d/yy h:mm a') }}</td>
                            <td width="5%">{{ roundToNearestDecimalPlace(ticket.precheckHours) | humanizeTime }}</td>
                            <td width="5%">{{ roundToNearestDecimalPlace(ticket.mobilizationHours) | humanizeTime }}</td>
                            <td width="5%">{{ roundToNearestDecimalPlace(ticket.standbyHours) | humanizeTime }}</td>
                            <td width="5%">{{ roundToNearestDecimalPlace(ticket.demobilizationHours) | humanizeTime }}</td>
                            <td width="5%">{{ roundToNearestDecimalPlace(ticket.postcheckHours) | humanizeTime }}</td>
                            <td width="7%">{{ roundToNearestDecimalPlace(ticket.indirectHours) }}</td>
                            <td width="7%">{{ roundToNearestDecimalPlace(ticket.directHours) }}</td>
                            <td width="7%">{{ roundToNearestDecimalPlace(ticket.indirectHours + ticket.directHours) }}</td>
                        </tr>
                        <tr v-if="index === driver.tickets.length - 1" class="footer">
                            <th colspan="7">Total</th>
                            <td>{{ roundToNearestDecimalPlace(driver.totals.precheckHours) | humanizeTime }}</td>
                            <td>{{ roundToNearestDecimalPlace(driver.totals.mobilizationHours) | humanizeTime }}</td>
                            <td>{{ roundToNearestDecimalPlace(driver.totals.standbyHours) | humanizeTime }}</td>
                            <td>{{ roundToNearestDecimalPlace(driver.totals.demobilizationHours) | humanizeTime }}</td>
                            <td>{{ roundToNearestDecimalPlace(driver.totals.postcheckHours) | humanizeTime }}</td>
                            <td>{{ roundToNearestDecimalPlace(driver.totals.indirectHours) }}</td>
                            <td>{{ roundToNearestDecimalPlace(driver.totals.directHours) }}</td>
                            <td>{{ roundToNearestDecimalPlace(driver.totals.hours) }}</td>
                        </tr>
                    </tbody>
                </table>
            </tbody>
        </table>
    </div>
</template>

<script>
import truncate from 'lodash/truncate';
import { formatDate, formatDateTime, roundToNearestDecimalPlace } from '@/utils/formatting';
import ReportMetaRow from './ReportMetaRow';

export default {
    name: 'TimesheetReport',

    components: { ReportMetaRow },

    props: {
        report: { type: Object, required: true },
        timeZone: { type: String, required: true },
    },

    computed: {
        dates() {
            const startDate = formatDate(this.report.startAt, this.timeZone);
            const endDate = formatDate(this.report.endAt, this.timeZone);
            return `${startDate} - ${endDate}`;
        },
    },

    methods: {
        truncate,
        formatDate,
        formatDateTime,
        roundToNearestDecimalPlace,
    },
}
</script>

<style lang="scss" scoped>
@import 'globals.scss';

.TimesheetReport {
    // Adds margin to the top of each page break
    thead:before {
        content: '';
        display: block;
        margin-top: $admin-gutter;
    }

    .metaHeader {
        margin-bottom: 40px;
    }

    .metaHeader h1 {
        float: left;
    }

    .metaHeader .third {
        float: right;
    }

    .footer th {
        border: none;
        text-align: right;
    }

    table.tickets {
        margin-bottom: 20px;
    }

    h2 {
        margin: 20px 0 10px;
    }
}
</style>
